import React, { useState, useEffect, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import axios from "axios";
import { CircularProgress, Typography, Container, Button, Box } from "@material-ui/core";
import "./AgentSettings.css";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    height: "100%",
  },
  treeContainer: {
    flexGrow: 1,
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    marginLeft: theme.spacing(2),
  },
  button: {
    marginBottom: theme.spacing(2),
  },
}));

export default function AgentPersonalInfo(props) {
  const classes = useStyles();

  const [agentsTree, setAgentsTree] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState([]);

  const renderTree = useCallback((node) => (
    <TreeItem key={node.id} nodeId={String(node.id)} label={node.name}>
      {node.children?.map(renderTree)}
    </TreeItem>
  ), []);

  const fetchAgentTree = async (url) => {
    try {
      setLoading(true);

      const response = await axios.get(url);

      setAgentsTree(response.data);

      const allNodeIds = getAllNodeIds(response.data);
      setExpandedNodes(allNodeIds);

    } catch (err) {
      console.error(err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGetParents = () => {
    const url = process.env.REACT_APP_API2_URL + "/Agent/GetAgentTreeParents?prmIdAgent=" + props.IdAgent;
    fetchAgentTree(url);
  };

  const handleGetChilds = () => {
    const url = process.env.REACT_APP_API2_URL + "/Agent/GetAgentTree?prmIdAgent=" + props.IdAgent;
    fetchAgentTree(url);
  };

  useEffect(() => {
    //handleGetChilds();
  }, [props.IdAgent]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }

  return (
    <Container className={classes.root}>
      <div className={classes.treeContainer}>
        {agentsTree && (
          <TreeView
            aria-label="agent hierarchy"
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            defaultExpanded={expandedNodes}
          >
            {renderTree(agentsTree)}
          </TreeView>
        )}
      </div>
      <Box className={classes.buttonContainer}>
        <Button variant="contained" color="primary" className={classes.button} onClick={handleGetParents}>
          Get Parents
        </Button>
        <Button variant="contained" color="primary" className={classes.button} onClick={handleGetChilds}>
          Get Children
        </Button>
      </Box>
    </Container>
  );
}

// Función para obtener todos los IDs de los nodos
const getAllNodeIds = (nodes) => {
  let allIds = [];
  const traverse = (node) => {
    allIds.push(String(node.id));
    if (node.children && node.children.length > 0) {
      node.children.forEach((child) => traverse(child));
    }
  };
  traverse(nodes);
  return allIds;
};